(() => {
  const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  if (reduceMotionQuery.matches) {
    document.documentElement.classList.add('pe-motion-reduced');
    return;
  }

  const revealSelectors = [
    '.pe-bf-entry .pe-bf__heading',
    '.pe-bf-entry > .pe-bf__art',
    '.pe-bf-entry > .pe-bf__art-placeholder',
    '.pe-bf-entry .pe-bf__products',
    '.pe-bf-channel-compact',
    '.pe-bf-permanent .pe-bf__art',
    '.pe-bf-permanent .pe-bf__art-placeholder',
    '.pe-bf-permanent .pe-bf__whatsapp-copy',
    '.home-hero',
    '.home-hero .hero-background',
    '.home-hero .hero-copy .kicker',
    '.home-hero .hero-copy h1',
    '.home-hero .hero-copy > p:not(.kicker)',
    '.home-hero .hero-copy > div',
    '.trust-strip',
    '.trust-strip > div',
    '.home-section .section-title',
    '.pe-shop-by-team__heading',
    '.pe-shop-team-card',
    '.club-card',
    '.league-grid > a',
    '.product-grid > .grid__item',
    '.details-section',
    '.details-section .detail-visual',
    '.details-section .detail-copy',
    '.story-card',
    '.feedback-card',
    '.pe-feedback article',
    '.product__media-wrapper',
    '.product__info-wrapper',
    '.collection-hero',
    '.main-page-title',
    '.facets-wrapper'
  ];

  const staggerContainers = [
    '.product-grid',
    '.pe-shop-by-team__rail',
    '.club-grid',
    '.league-grid',
    '.grid--peek'
  ];

  const motionProfiles = [
    { selector: '.pe-bf-entry > .pe-bf__art', type: 'fade' },
    { selector: '.pe-bf-entry .pe-bf__products', type: 'fade' },
    { selector: '.pe-bf-permanent .pe-bf__whatsapp-copy', delay: '120ms' },
    { selector: '.home-hero', type: 'fade', delay: '0ms' },
    { selector: '.home-hero .hero-background', type: 'hero-media', delay: '0ms' },
    { selector: '.home-hero .hero-copy .kicker', type: 'from-left', delay: '120ms' },
    { selector: '.home-hero .hero-copy h1', type: 'hero-title', delay: '220ms' },
    { selector: '.home-hero .hero-copy > p:not(.kicker)', type: 'from-left', delay: '360ms' },
    { selector: '.home-hero .hero-copy > div', type: 'from-left', delay: '500ms' },
    { selector: '.details-section .detail-visual', type: 'from-left' },
    // Product detail copy reaches the viewport edge: a lateral reveal leaked 7px.
    // Keep the fade on product pages without clipping editorial artwork elsewhere.
    { selector: '.details-section .detail-copy', type: document.querySelector('[data-product-main]') ? 'fade' : 'from-right', delay: '120ms' },
    { selector: '.collection-hero', type: 'from-left' },
    { selector: '.product__media-wrapper', type: 'from-left' },
    { selector: '.product__info-wrapper', type: 'from-right', delay: '120ms' }
  ];

  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, {
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.12
    })
    : null;

  const revealNow = (element) => {
    element.classList.add('pe-reveal', 'is-visible');
  };

  const bindReveal = (element) => {
    if (element.dataset.peMotionBound === 'true') return;
    element.dataset.peMotionBound = 'true';
    element.classList.add('pe-reveal');

    if (!observer) {
      element.classList.add('is-visible');
      return;
    }

    const rect = element.getBoundingClientRect();
    if (rect.top < window.innerHeight * 0.92) {
      revealNow(element);
      return;
    }

    observer.observe(element);
  };

  const applyStagger = (root) => {
    staggerContainers.forEach((selector) => {
      root.querySelectorAll(selector).forEach((container) => {
        Array.from(container.children).forEach((child, index) => {
          if (child.style.getPropertyValue('--pe-motion-delay')) return;
          child.style.setProperty('--pe-motion-delay', `${Math.min(index, 8) * 70}ms`);
        });
      });
    });
  };

  const applyProfiles = (root) => {
    motionProfiles.forEach(({ selector, type, delay }) => {
      root.querySelectorAll(selector).forEach((element) => {
        if (type && !element.dataset.peMotion) {
          element.dataset.peMotion = type;
        }

        if (delay && !element.style.getPropertyValue('--pe-motion-delay')) {
          element.style.setProperty('--pe-motion-delay', delay);
        }
      });
    });
  };

  const initMotion = (root = document) => {
    document.documentElement.classList.add('pe-motion-enabled');
    applyStagger(root);
    applyProfiles(root);

    revealSelectors.forEach((selector) => {
      root.querySelectorAll(selector).forEach(bindReveal);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initMotion());
  } else {
    initMotion();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initMotion(event.target);
  });

  const mutationObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        initMotion(node);
      });
    });
  });

  mutationObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();